export const ELEMENT_IDS = {
  ABOUT_US: 'about-us',
  PRODUCT_TITLE: 'products-title',
  OTHER_PRODUCTS: 'other-products',
  FOOTER: 'footer',
  CONTENT_WRAPPER: 'content-wrapper',
};
